<template>
  <div>
  <v-flex>

      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" @click="getCreate" v-on="on">Nueva Cita</v-btn>
          </template>
          <create @create="create" ref="create"></create>
        </v-dialog>
      </v-toolbar>
  </v-flex>

        <v-dialog v-model="dialogEdit" max-width="500px">
          <edit @edit="edit" ref="edit"></edit>
        </v-dialog>

    <v-flex>
      <v-card>
        <v-card-title>
          <h4>
            {{ $t('quote.title') }}

          </h4>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="quotes"
          :search="search"
          :loading="loadingTable"
        >

          <template slot="items" slot-scope="props" >
            <td class="text-xs-center">{{ props.item.description  }}</td>
            <td class="text-xs-center">
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="editItem(props.item, dialogEdit=true)"
                  slot="activator"
                >
                  edit
                </v-icon>
                <span>Editar</span>
              </v-tooltip>
            </td>

          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
  import create from './create'
  import edit from './edit'
    import axios from 'axios'

    export default {

        name: "show",
        data() {
            return {
                dialogEdit: false,
                loadingTable: false,
                headers: [
                    { text: 'Descripcion', align: 'center', value: 'description' },
                    { text: 'Acción', align: 'center', value: 'description' }
                ],
                search: "",
                quotes: [],
                dialog: false
            }
        },
        methods: {
            getCreate(){
                this.$refs.create.getCreate()
            },
            edit(){
                this.getQuotes()
              this.dialogEdit = false
            },
            create (){
                this.dialog = false
                this.getQuotes()
            },
            getQuotes () {
                this.loadingTable = true
                axios.get('/api/quotes/all')
                    .then(resp=>{
                        this.quotes = resp.data.data
                        this.loadingTable = false

                    })
            },
            editItem(item){
            this.$refs.edit.getEdit(item)
            }
        },
        created() {
            this.getQuotes()
        },
        components: {
            create,
            edit
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/quotes/show.vue